import { getCurrentUserHasCore } from '@wix/da-shared-react/pkg/publicSession';
import { connect } from 'react-redux';
import { AppState } from '../../../../types/store';
import { getInstallableModuleInfo } from '../../../selectors/layout';
import { Props } from './AddWidget';

export type ConnectedKeys = 'hasCoreMembership' | 'installableModulesInfo';

export type ContainerProps = Without<Props, ConnectedKeys>;

const mapStateToProps = (
  state: AppState,
  props: ContainerProps
): Partial<Props> => ({
  hasCoreMembership: getCurrentUserHasCore(state),
  installableModulesInfo: props.installableModules.map(
    ({ moduleName, zone }) => {
      const m = getInstallableModuleInfo(state, props.section, zone) || [];
      return m.find(module => module.moduleName === moduleName);
    }
  ),
});

export default connect(mapStateToProps);
